function ProductSwatches() {  
  var ss_all = $('.single-option-selector');

  ss_all.each(function() {
    var ss = $(this);
    var sw = '<div class="swatches" data-select-id="'+ss.attr('id')+'">';

    ss.children().each(function(index) {
      var v = $(this).attr('value');
      var i = index;
      var name = $(this).text();
      var selected = (v == ss.val())?'selected':'';
      sw += `	<label for="swatch">${name}</label>
				<input name="swatch" class="swatch-btn" type="radio" data-index="${i}" data-val="${v.replace(/"/g, "&quot;")}" />
			`;
    });
    sw += '</div>';

    ss.before(sw);
  });

  $('.swatch-btn').on('click', function(e) {
    var index = $(this).attr('data-index');
    var v = $(this).attr('data-val');
    //console.log(v);

    var ss = $('select#' + $(this).parent().attr('data-select-id'));
    ss.val(v).trigger('change');

    $('.swatch-btn.selected', $(this).parent()).removeClass('selected');
    $(this).addClass('selected');  
  });
  
  $(document).ready(function() {
    $('.swatch-btn').first().trigger('click');
  });
}